import React, { useEffect, useState } from "react";
import {
  PiPhoneCallLight,
  PiPhoneIncomingLight,
  PiPhoneOutgoingLight,
  PiCoffeeLight,
  PiCheckCircleLight,
  PiChartBarLight,
  PiClockLight,
  PiTargetLight,
} from "react-icons/pi";

const StatsBar = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateSize = () => setIsMobile(window.innerWidth <= 768);
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const outerContainerStyle = {
    overflowX: "auto",
    padding: "8px 0",
    WebkitOverflowScrolling: "touch",
    width: "100%",
  };

  const innerContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: isMobile ? "4px" : "8px",
    gap: isMobile ? "8px" : "12px",
    maxWidth: "100%",
    boxSizing: "border-box",
  };

  const cardStyle = {
    background: "white",
    borderRadius: "10px",
    padding: "8px",
    width: "calc(11.11% - 12px)",
    minWidth: "90px",
    height: "80px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 0.2s ease",
    borderTop: "3px solid",
    flexShrink: 1,
  };

  const iconContainerStyle = {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const valueStyle = {
    fontWeight: "600",
    fontSize: isMobile ? "12px" : "13px",
    textAlign: "center",
    lineHeight: "1.2",
  };

  const labelStyle = {
    fontSize: isMobile ? "9px" : "10px",
    color: "#666",
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
  };

  const getColor = (index) => {
    const colors = [
      "#FF6B6B",
      "#4ECDC4",
      "#45B7D1",
      "#FFA07A",
      "#98D8C8",
      "#7986CB",
      "#9575CD",
      "#64B5F6",
      "#4DB6AC",
      "#81C784",
      "#FFD54F",
      "#F06292",
    ];
    return colors[index % colors.length];
  };

  const stats = [
    {
      icon: <PiClockLight size={16} />,
      value: "04:10:03 PM",
      label: "Time",
    },
    {
      icon: <PiTargetLight size={16} />,
      value: "0%",
      label: "SLE",
    },
    {
      icon: <PiPhoneCallLight size={16} />,
      value: "0",
      label: "Total calls",
    },
    {
      icon: <PiPhoneOutgoingLight size={16} />,
      value: "0",
      label: "Calls made",
    },
    {
      icon: <PiPhoneIncomingLight size={16} />,
      value: "0",
      label: "Calls received",
    },
    {
      icon: <PiPhoneCallLight size={16} />,
      value: "00:00:00",
      label: "On call",
    },
    {
      icon: <PiCoffeeLight size={16} />,
      value: "00:00:00",
      label: "Break duration",
    },
    {
      icon: <PiCheckCircleLight size={16} />,
      value: "00:00:00",
      label: "Logged duration",
    },
    {
      icon: <PiChartBarLight size={16} />,
      value: "-",
      label: "Network",
    },
  ];

  return (
    <div style={outerContainerStyle}>
      <div style={innerContainerStyle}>
        {stats.map((stat, index) => {
          const color = getColor(index);
          return (
            <div
              key={index}
              style={{
                ...cardStyle,
                borderTopColor: color,
              }}
            >
              <div
                style={{ ...iconContainerStyle, backgroundColor: `${color}20` }}
              >
                {React.cloneElement(stat.icon, { color: color })}
              </div>
              <div style={valueStyle}>{stat.value}</div>
              <div style={labelStyle}>{stat.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatsBar;
